import request from '../utils/request'

export default {
  // 获取所有人员
  findAll(params) {
    return request.get('/api/shooter', { params })
  },
  
  // 根据ID获取人员
  findById(id) {
    return request.get(`/api/shooter/${id}`)
  },
  
  // 添加人员
  add(shooter) {
    return request.post('/api/shooter', shooter)
  },
  
  // 更新人员
  update(id, shooter) {
    return request.put(`/api/shooter/${id}`, shooter)
  },
  
  // 删除人员
  delete(id) {
    return request.delete(`/api/shooter/${id}`)
  },
  
  // 批量删除
  deleteBatch(ids) {
    return request.delete('/api/shooter/batch', { data: ids })
  },

  // 同场次内人员本地编号唯一校验
  checkShooterNo(params) {
    return request.get('/api/shooter/checkShooterNo', { params })
  },

  downloadTemplate() {
    return request({
      url: '/api/shooter/downloadTemplate',
      method: 'get',
      responseType: 'blob' // 明确指定响应为二进制流（Excel文件）
    })
  },

  importShooters(formData) {
    return request({
      url: '/api/shooter/importShooters',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data' // 上传文件需指定该类型
      }
    });
  },
}